import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VContainer,{staticClass:"px-10",attrs:{"fluid":""}},[_c('h2',{staticClass:"mt-5 white--text display-1 font-weight-light underline"},[_vm._v("Bussiness Scopes")]),_c(VRow,{staticClass:"mt-10"},_vm._l((_vm.scopes),function(scope){return _c(VCol,{key:scope._uid,attrs:{"cols":"4"}},[_c(VCard,{on:{"click":function($event){return _vm.selectScope(scope)}}},[_c(VCardTitle,[_vm._v(_vm._s(scope.name))])],1)],1)}),1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }